import { axios } from '@/configs'
import type {
  SignInParams,
  SignUpEmailParams,
  SignUpResponse,
  SignInResponse,
  ActivateResponse,
  PasswordResetPerformResponse,
} from '@/root/shared-types/api/auth'

type LocalSignInParams = SignInParams & {
  rememberMe?: boolean
}

export const signIn = async (body: LocalSignInParams) => {
  return axios.post<SignInResponse>('auth/signin', body)
}

export const signInByEmailOrPhone = async (body: LocalSignInParams) => {
  return axios.post<SignInResponse>('auth/emailOrPhoneNumber', body)
}

export const signUpWithEmail = async ({ locale, ...body }: SignUpEmailParams) => {
  const headers = locale ? { 'Accept-Language': locale } : undefined
  return axios.post<SignUpResponse>('auth/signup', body, { headers })
}

export const activateEmail = async (hash: string) => {
  return axios.post<ActivateResponse>(`auth/activate/${hash}`)
}

export const passwordResetPrepare = async (email: string) => {
  return axios.post('auth/password-reset-prepare', { email })
}

export const passwordResetValidate = async (token: string) => {
  return axios.post('auth/password-reset-validate', { token })
}

export const passwordResetPerform = async (token: string, newPassword: string, confirmedNewPassword: string) => {
  return axios.post<PasswordResetPerformResponse>('auth/password-reset-perform', {
    token,
    newPassword,
    confirmedNewPassword,
  })
}

export const logout = async () => {
  return axios.post('auth/logout')
}

export const clearAuthSession = async () => {
  return axios.delete<{ success: boolean }>('auth/session')
}

export const getAuthSession = async () => {
  return axios.get<{ isAuthenticated: boolean }>('auth/session')
}

export const setAuthSessionFromHandoff = async (token: string) => {
  return axios.post<{ success: boolean }>('auth/handoff', { token })
}
